module.exports = __webpack_public_path__ + "420acb297620f852fb9b08587e76f6d0.jpg";